import { useEffect, useRef, useState } from 'react';
import { useGameSounds } from '@educaplay/core';
import { DICTADO_SOUNDS } from '../../utils/constants';
import Page from '../Page';
import { useSelector } from 'react-redux';

const DELAY_FOCUS_SELECTOR = 100;
export default function Note(props) {
    const { onChange, onFocus, onBlur, focusNote } = props;
    const gameSounds = useGameSounds();
    const [divContent, setDivContent] = useState('');
    const noteRef = useRef(null);
    const currentQuestion = useSelector(state => state.game.questions[state.game.currentIndex]);
    const [scrollHeight, setScrollHeight] = useState(0);

    const changeHandler = (e) => {
        setScrollHeight(noteRef.current.scrollHeight);
        if (scrollHeight !== noteRef.current.scrollHeight) noteRef.current.scrollTo(0, noteRef.current.scrollHeight);
        const value = e.target.innerText;
        if (value.length > divContent.length) gameSounds.play(DICTADO_SOUNDS.LOW_WRITE);
        setDivContent(value);
        onChange(value);
    }

    const onPasteHandler = e => {
        e.preventDefault();
        // clean the clipboard data to avoid pasting images or other non-text data
        const text = e.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", false, text);
    }

    useEffect(() => {
        setDivContent('');
        noteRef.current.innerText = '';
    }, [currentQuestion.id, noteRef])

    const focusHandler = () => {
        onFocus?.();
        setTimeout(() => {
            const selection = window.getSelection();
            const domRange = selection.getRangeAt(0);
            if (domRange) {
                domRange.setStart(noteRef.current, noteRef.current.childNodes.length);
                domRange.setEnd(noteRef.current, noteRef.current.childNodes.length);
            }
        }, DELAY_FOCUS_SELECTOR);
    }

    return (
        <Page
            reduceHeight={focusNote}
            ref={noteRef}
            onInput={changeHandler}
            onFocus={focusHandler}
            onBlur={onBlur}
            onPaste={onPasteHandler}
            autoCorrect="off"
            spellCheck="false"
            contentEditable
        />
    )
}
